<section>

    <div class="grid grid-cols-4 grid-rows-1">

        <div></div>
        <div class="p-5 bg-white col-span-3 rounded-lg">

            <h1 class="font-semibold">Client Form</h1>
            <hr class="my-3">
            <ul>
                <li class="grid grid-cols-3">

                    <span></span>
                    <div></div>

                </li>
            </ul>

        </div>

    </div>


</section>